import React from 'react';
import Text from './text';

const Label = props => <Text fontSize={2} {...props} />;

export default Label;
